// import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Stethoscope,
  Baby,
  Brain,
  Sparkles,
  Activity,
  Flower2,
} from "lucide-react";
import UseScrollAnimation from "../Elements/ScrollAnimation";
import ServicesConditionsSupported from "./Page_Sections/servicesConditionsSupported";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";

const services = [
  {
    icon: Stethoscope,
    title: "Acute Care",
    desc: "Fast-acting support for colds, flu, injuries, and short-term issues — usually one or two follow-ups.",
  },
  {
    icon: Activity,
    title: "Chronic Conditions",
    desc: "Long-standing concerns like allergies, digestive issues, hormonal imbalance, and autoimmune patterns.",
  },
  {
    icon: Baby,
    title: "Pediatric Care",
    desc: "Gentle, age-appropriate remedies for children — from infants through adolescence.",
  },
  {
    icon: Brain,
    title: "Mental & Emotional",
    desc: "Compassionate support for anxiety, grief, sleep, and overwhelm — alongside any current care.",
  },
  {
    icon: Flower2,
    title: "Women's Health",
    desc: "Cycles, fertility, perimenopause, and postpartum support with individualized remedies.",
  },
  {
    icon: Sparkles,
    title: "Wellness & Vitality",
    desc: "For those seeking deeper resilience, energy, and balance — even without a specific diagnosis.",
  },
];

// const process = [
//   {
//     n: "01",
//     t: "Discovery call",
//     d: "A complimentary 15-minute conversation to make sure homeopathy is the right fit.",
//   },
//   {
//     n: "02",
//     t: "Initial consultation",
//     d: "A 90-minute deep-dive into your history, symptoms, and life context.",
//   },
//   {
//     n: "03",
//     t: "Personalized remedy",
//     d: "A single, carefully chosen classical remedy is prescribed for your case.",
//   },
//   {
//     n: "04",
//     t: "Follow-up care",
//     d: "Periodic check-ins (typically every 4–8 weeks) to track progress and refine.",
//   },
// ];

const Services = () => {
  UseScrollAnimation(); // ✅ just call it

  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox">
          <section className="Disclaimer_Section animate-top">
            <div className="Disclaimer_SectionBox">
              <div className="Disclaimer_Section_TitleHeadingContent">
                <p className="Disclaimer_Section_Title animate-top">Services</p>
                <span className="Disclaimer_Section_Heading animate-top">
                  Care tailored to you.
                </span>
                <p className="Disclaimer_Section_Content animate-top">
                  From acute concerns to deep chronic patterns, every
                  prescription is shaped around the unique way you experience
                  your symptoms.
                </p>
              </div>
            </div>
          </section>
          {/* Process */}
          <section className="ServiceWorking_Section">
            <div className="ServiceWorking_Section_HighlightsBox00">
              {/* <div className="ServiceWorking_Section_TitleHeadingContent00">
                <p className="ServiceWorking_Section_Title00 animate-top">
                  The Process
                </p>
                <h1 className="ServiceWorking_Section_Heading00 animate-top">
                  <span className="ServiceWorking_Section_HeadingItalic00">
                    What working together looks like.
                  </span>
                </h1>
              </div>

              <span className="ServiceWorking_Section_HighlightsBox animate-top">
                {process.map((p) => (
                  <article
                    key={p.n}
                    className="ServiceWorking_Section_HighlightBox animate-top"
                  >
                    <span className="ServiceWorking_Section_primaryNo animate-top">
                      {p.n}
                    </span>
                    <h3 className="ServiceWorking_Section_HighlightBox_Heading animate-top">
                      {p.t}
                    </h3>
                    <p className="ServiceWorking_Section_HighlightBox_Description animate-top">
                      {p.d}
                    </p>
                  </article>
                ))}
              </span> */}

              <div className="ServiceWorking_Section_TitleHeadingContent00">
                <p className="ServiceWorking_Section_Title00 animate-top">
                  Consultation & Fees
                </p>
                <h1 className="ServiceWorking_Section_Heading00 animate-top">
                  What to expect when working together.
                </h1>
              </div>

              <div className="ServiceWorking_Section_HighlightsBox">
                {/* First Consultation */}
                <div className="ServiceWorking_Section_HighlightBox animate-top">
                  <h3 className="PractitionerHighlights_Section_HighlightBox_Heading00 animate-top">
                    First Consultation: $275
                  </h3>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    <strong>Upto 60-90 min</strong>
                  </p>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    Detailed case taking and evaluation of the clients’ issues
                    on physical, emotional and mental levels, which could take
                    upto an hour to hour and half. Any cases requiring time
                    which exceeds the above given time will be considered as
                    another appointment and needs to be scheduled if time
                    doesn’t permit the same day.
                  </p>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    Upto 3-free brief 5-15 min (phone call/text/email) follow
                    ups WITHIN 30 days of first consultation ONLY can be availed
                    if needed for dosage adjustment or any other concerns.
                  </p>
                </div>

                {/* Follow-up */}
                <div className="ServiceWorking_Section_HighlightBox animate-top">
                  <h3 className="PractitionerHighlights_Section_HighlightBox_Heading00 animate-top">
                    Follow up of established Client: $100
                  </h3>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    <strong>Upto 30-40 min</strong>
                  </p>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    Recommended every 4-6 weeks. If the client cannot keep up
                    with the 4-6 weeks schedule and passes 6 months, the case
                    will have to be re-evaluated as a new case.
                  </p>
                </div>

                {/* Acute */}
                <div className="ServiceWorking_Section_HighlightBox animate-top">
                  <h3 className="PractitionerHighlights_Section_HighlightBox_Heading00 animate-top">
                    Acute Consultation: $145
                  </h3>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    <strong>Upto 30 min</strong>
                  </p>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    Will follow the case for 7 days, as needed. For fevers etc -
                    Brief 5-10 min updates as recommended by your practitioner
                    in the morning between 8:30 - 9:00 EST, and/or evening
                    between 5:00-5:30PM EST - need based, varies for each case.
                  </p>
                </div>

                {/* Notes */}
                <div className="ServiceWorking_Section_HighlightBox animate-top">
                  {/* <h3 className="PractitionerHighlights_Section_HighlightBox_Heading00 animate-top">
                    Important Notes
                  </h3> */}
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    Any consultation fees are due on the day of the appointment,
                    you’ll be receiving an invoice via email for each
                    consultation.
                  </p>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    Homeopathic Remedies are not included in the appointment
                    cost and have to be purchased through homeopathic pharmacies
                    as and when recommended.
                  </p>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    Depending upon each case, pls allow 2-5 business days for
                    your remedy recommendation which will be sent via email.
                  </p>
                </div>
              </div>

              <div className="ServiceWorking_Section_Buttons">
                <Link
                  to="/contact-us"
                  className="ServiceWorking_Section_Button01 animate-top"
                >
                  {/* <span>Schedule your consultation</span> */}
                  <span>Book Appointment Today</span>
                  <ArrowRight className="ServiceWorking_Section_Button01_ArrowRight" />
                </Link>
              </div>
            </div>
          </section>
          <section className="PractitionerHighlights_Section00">
            <div className="PractitionerHighlights_Section_HighlightsBox00">
              {services.map((s) => (
                <div
                  key={s.title}
                  className="PractitionerHighlights_Section_HighlightBox00 animate-top"
                >
                  <s.icon
                    className="PractitionerHighlights_Section_HighlightBox_Icon00 animate-top"
                    strokeWidth={1.5}
                  />
                  <h3 className="PractitionerHighlights_Section_HighlightBox_Heading00 animate-top">
                    {s.title}
                  </h3>
                  <p className="PractitionerHighlights_Section_HighlightBox_Description00 animate-top">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <ServicesConditionsSupported />

          {/* <ThreeTestimonials /> */}

          {/* <AboutThePractitioner /> */}
        </div>
      </div>
    </>
  );
};

export default Services;
